declare const window: any

interface AddToCartParams {
  productId: string | number
  name?: string
  price?: number | string
  currency?: string
}

const parsePrice = (price?: number | string): number | undefined => {
  if (price === undefined || price === null) return undefined
  if (typeof price === 'number') return isNaN(price) ? undefined : price
  const parsed = parseFloat(price.replace(/[^0-9.]/g, ''))
  return isNaN(parsed) ? undefined : parsed
}

export const trackMetaPixelEvent = (
  event: string,
  params: Record<string, any> = {}
) => {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return
  window.fbq('track', event, params)
}

export const trackAddToCart = ({
  productId,
  name,
  price,
  currency = 'USD',
}: AddToCartParams) => {
  trackMetaPixelEvent('AddToCart', {
    content_ids: [String(productId)],
    content_type: 'product',
    content_name: name,
    value: parsePrice(price),
    currency,
  })
}
